import * as React from "react";
import { Container, Typography, Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import CaseStudiesFeed from "components/CaseStudy/CaseStudiesFeed";

const FeaturedCaseStudies = props => {

	const { title, caseStudies } = props;

    return (
        <Box sx={{ padding: '96px 0 102px' }} component={'section'}>
            <Container>
                <Grid container spacing={"6px"} justifyContent={'center'}>
                    <Grid size={{ xs: 12 }}>
                        <Typography sx={{ marginBottom: "32px" }} variant={"h1"} component={"h2"}>{title}</Typography>
                    </Grid>
                </Grid>
            </Container>
			<CaseStudiesFeed caseStudies={caseStudies} />
        </Box>
    );
};

export default FeaturedCaseStudies;
